import { render, staticRenderFns } from "./person-description-alternative.vue?vue&type=template&id=0f0951a3&lang=pug&"
import script from "./person-description-alternative.vue?vue&type=script&lang=js&"
export * from "./person-description-alternative.vue?vue&type=script&lang=js&"
import style0 from "./person-description-alternative.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports